import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.contact.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.contact.fields.name'),
  },
  {
    name: 'company',
    label: i18n('entities.contact.fields.company'),
    render: exporterRenders.relationToOne('companyName'),
  },
  {
    name: 'role',
    label: i18n('entities.contact.fields.role'),
  },
  {
    name: 'email',
    label: i18n('entities.contact.fields.email'),
  },
  {
    name: 'phoneNumber',
    label: i18n('entities.contact.fields.phoneNumber'),
  },
  {
    name: 'alternateNumber',
    label: i18n('entities.contact.fields.alternateNumber'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.contact.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.contact.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
